// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4131) return "static/chunks/4131-2c47f8e0ed1ef830.js";
	if (chunkId === 6084) return "static/chunks/4e6af11a-73035587000631f9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"436":"1873c11b45a3fe6f","511":"f2665ed917533187","1442":"d68093e33ad4e1e1","3471":"51f255b146a9d073","9754":"69c8e77b5ba5de5f"}[chunkId] + ".js";
};